const API_URL = 'https://hamaca.carreticacuentera.com/info';
const SOPAS = '/sopas' ;
const BOTON_COLOR = 'FFFFFF'
const PALETA = [
    '35C580',
    'DBDF69',
    'FE913D',
    'F24A4A',
    'C12570',
    'D71ED0',
    '9E1DD5',
    '472DCF',
    '3C7CEE',
    '4AC2F6',
    '63DBD3',
    '3E913E'
]

const PALETA_ACTIVA = [
    '268C5B',
    'B0B354',
    'D97B34',
    'C53B3B',
    '941C56',
    'AD19A8',
    '7A15A5',
    '35209C',
    '2D5DB3',
    '3996BF',
    '459B95',
    '2C6B2D'
]

export { API_URL, SOPAS, PALETA, PALETA_ACTIVA, BOTON_COLOR };